import React, { useState } from 'react';
import Fade from 'react-reveal/Fade';
import Flip from 'react-reveal/Flip';
import 'react-chatbot-kit/build/main.css'

// import chatbotImg from '../img/chatbot/bot6.png';
import ChatboxContainer from './chatbox_container';

function Chatbox(props) {
    const [showBot, toggleBot] = useState(false);
    return (
        <div className="App">
            {showBot && (
                <Fade big>
                    <div className="app-chatbot-container">
                        <div className="react-chatbot-kit-chat-container">
                            <ChatboxContainer {...props} />
                        </div>
                    </div>
                </Fade>
            )}
            <Flip left cascade>
                <button
                    aria-label="button"
                    name="chatbot opener"
                    type="button"
                    onClick={() => toggleBot((prev) => !prev)}
                    className="app-chatbot-button"
                >
                    <img alt="Bot" src="/images/chatbot/live-chat.png" />
                </button>
            </Flip>
        </div>
    );
}

export default Chatbox;
